import data from './BoatTrips.yaml'
import { WithPage } from "../Components/PageSections/WithPage";

export default function BoatTrips() {

  return WithPage(data, "trips")
  
}